import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mb-3" };
const _hoisted_2 = ["data-bs-target"];
const _hoisted_3 = ["id"];
const _hoisted_4 = { class: "mb-3" };
import { onMounted, ref, watch } from 'vue';
import { responseMessages } from '@/Composables/responseMessages';
import axios from 'axios';
import ProductPriceTable from '@/Tenant/Components/ProductPriceTable.vue';
import { Select, useConfirm } from 'primevue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductPriceOption',
    props: {
        bottle: Object,
        bottlePrintArea: Object,
        lid: Object,
        lidPrintArea: Object,
        lidVariant: Object,
        lidVariantComponent: Object,
        package: Object,
        accessoryProduct: Object,
        deliveryTypeCountry: Object,
        //TODO: other relation types
        priceBundleUuid: {
            type: String,
            default: null
        },
        //only relevant for products with digital or silkscreen printing
        colorType: {
            type: Number,
            default: null //0 = digital, 1 = one color, etc.
        }
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage, showSuccessMessage } = responseMessages();
        const props = __props;
        const confirm = useConfirm();
        const componentId = ref(Math.random().toString(36).substring(2, 15));
        const relationType = ref(null);
        const relationUuid = ref(null);
        const newPriceBundleName = ref(null);
        const priceTableKey = ref(0);
        const availablePriceBundles = ref([]);
        const selectedPriceBundleUuid = ref(null);
        onMounted(() => {
            if (props.bottle) {
                relationType.value = 'bottles';
                relationUuid.value = props.bottle.uuid;
                newPriceBundleName.value = props.bottle.name + ', ' + props.bottle.volume + 'ml (Standard)';
            }
            if (props.bottlePrintArea) {
                relationType.value = 'bottlePrintAreas';
                relationUuid.value = props.bottlePrintArea.uuid;
                newPriceBundleName.value = props.bottlePrintArea.name + ', Druckbereich (' + props.bottlePrintArea.bottleName + ')';
            }
            if (props.lid) {
                relationType.value = 'lids';
                relationUuid.value = props.lid.uuid;
                newPriceBundleName.value = props.lid.name + ', Verschluss (Standard)';
            }
            if (props.lidPrintArea) {
                relationType.value = 'lids';
                relationUuid.value = props.lidPrintArea.uuid;
                newPriceBundleName.value = props.lidPrintArea.name + ', Verschluss-Druckbereich (Standard)';
            }
            if (props.lidVariant) {
                relationType.value = 'lidVariants';
                relationUuid.value = props.lidVariant.uuid;
                newPriceBundleName.value = props.lidVariant.name + ', Verschluss-Variante (Standard)';
            }
            if (props.lidVariantComponent) {
                relationType.value = 'lidVariantComponents';
                relationUuid.value = props.lidVariantComponent.uuid;
                newPriceBundleName.value = props.lidVariantComponent.name + ', Verschluss-Varianten-Komponente (Standard)';
            }
            if (props.package) {
                relationType.value = 'packages';
                relationUuid.value = props.package.uuid;
                newPriceBundleName.value = props.package.name + ', Verpackung (Standard)';
            }
            if (props.accessoryProduct) {
                relationType.value = 'accessoryProducts';
                relationUuid.value = props.accessoryProduct.uuid;
                newPriceBundleName.value = props.accessoryProduct.name + ', Zubehör (Standard)';
            }
            if (props.deliveryTypeCountry) {
                relationType.value = 'deliveryTypeCountries';
                relationUuid.value = props.deliveryTypeCountry.uuid;
                newPriceBundleName.value = props.deliveryTypeCountry.name + ', Versand (Standard)';
            }
            //TODO: other relation types
            if (props.priceBundleUuid) {
                selectedPriceBundleUuid.value = props.priceBundleUuid;
            }
            loadAvailablePriceBundles();
        });
        watch(selectedPriceBundleUuid, (newValue) => {
            if (newValue) {
                updateRelatedPriceBundle();
                priceTableKey.value++;
            }
        });
        function loadAvailablePriceBundles() {
            axios.post(route('admin.priceBundles.load')).then((response) => {
                availablePriceBundles.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function createPriceBundle() {
            confirm.require({
                message: 'Soll für das Produkt ein eigenes Preis-Bundle erstellt werden?',
                header: 'Neues Preis-Bundle?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Ja, erstellen',
                accept: () => {
                    axios.post(route('admin.priceBundles.store'), {
                        name: newPriceBundleName.value
                    }).then((response) => {
                        selectedPriceBundleUuid.value = response.data.uuid;
                        showSuccessMessage(response.data.message);
                    }).catch((error) => {
                        console.log(error);
                        showErrorMessage(error);
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function updateRelatedPriceBundle() {
            if (relationUuid.value == null || selectedPriceBundleUuid.value == props.priceBundleUuid) {
                return;
            }
            axios.post(route('admin.' + relationType.value + '.priceBundles.update', relationUuid.value), {
                price_bundle_uuid: selectedPriceBundleUuid.value,
                color_type: props.colorType
            }).then((response) => {
                showSuccessMessage('Preis-Bundle zugewiesen');
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("button", {
                        class: "btn btn-sm btn-secondary mb-3",
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": '#priceBundleSelection' + componentId.value
                    }, "Preis-Bundle erstellen/wählen", 8, _hoisted_2),
                    _createElementVNode("div", {
                        class: "collapse",
                        id: 'priceBundleSelection' + componentId.value
                    }, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[2] || (_cache[2] = _createElementVNode("label", null, "Gewähltes Preis-Bundle", -1)),
                            (availablePriceBundles.value)
                                ? (_openBlock(), _createBlock(_unref(Select), {
                                    key: 0,
                                    class: "w-100",
                                    modelValue: selectedPriceBundleUuid.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedPriceBundleUuid).value = $event)),
                                    options: availablePriceBundles.value,
                                    filter: "",
                                    optionLabel: "name",
                                    optionValue: "uuid",
                                    placeholder: "Preis-Bundle wählen"
                                }, null, 8, ["modelValue", "options"]))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "fw-bold my-3" }, "ODER", -1)),
                        _createElementVNode("button", {
                            class: "btn btn-success d-inline-flex align-items-center",
                            onClick: _cache[1] || (_cache[1] = ($event) => (createPriceBundle()))
                        }, [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "bi bi-plus-lg",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                    })
                                ], -1),
                                _createElementVNode("span", { class: "ms-2" }, "Neues Preis-Bundle", -1)
                            ]))])
                    ], 8, _hoisted_3)
                ]),
                (selectedPriceBundleUuid.value)
                    ? (_openBlock(), _createBlock(ProductPriceTable, {
                        priceBundleUuid: selectedPriceBundleUuid.value,
                        key: priceTableKey.value
                    }, null, 8, ["priceBundleUuid"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
